<div class="tank-debunker relative pb-4">
  @if (isModalDisplayed) {
    <div
      role="presentation"
      class="modal fixed top-0 left-0 z-50 flex h-full w-full flex-row justify-center bg-black/75"
      (click)="onBackdropClick($event)"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Add bunker"
        class="modal-content relative mt-20 h-3/5 w-1/2 p-4 opacity-100"
      >
        <div>
          <div class="form-group">
            <label for="fuel-grade">Fuel Grade: </label>
            <select
              id="fuel-grade"
              class="pointer mr-2"
              [(ngModel)]="newBdn.fuelGrade"
            >
              <option
                value=""
                disabled
                selected
              >
                Select...
              </option>
              @for (fuelGrade of fuelGrades; track fuelGrade) {
                <option [value]="fuelGrade">{{ fuelGrade }}</option>
              }
            </select>
            @if (bdn) {
              <span class="bdn-ref">{{ bdn }}</span>
            }
          </div>
        </div>

        <div class="my-2">
          <h2>Quantity</h2>
          <label for="bdn_quantity_ordered">Ordered: </label>
          <input
            [(ngModel)]="newBdn.quantityOrdered"
            type="number"
            class="mr-2 w-24 border px-1"
            id="bdn_quantity_ordered"
          />
          <label for="bdn_quantity_received">Received: </label>
          <input
            [(ngModel)]="newBdn.quantityReceived"
            class="w-24 border px-1"
            type="number"
            id="bdn_quantity_received"
          />
        </div>

        <div class="my-4">
          <h2>TtW Emission Factor</h2>
          <div class="form-group">
            <label for="bdn_cf_co2">Cf CO2 (gCO2/gFuel)</label>
            <input
              [(ngModel)]="newBdn.cfCo2"
              class="w-24 border px-1"
              type="number"
              id="bdn_cf_co2"
            />
          </div>

          <div class="form-group">
            <label for="bdn_cf_ch4">Cf CH4 (gCO2/gFuel)</label>
            <input
              [(ngModel)]="newBdn.cfCh4"
              class="w-24 border px-1"
              type="number"
              id="bdn_cf_ch4"
            />
          </div>

          <div class="form-group">
            <label for="bdn_cf_n2o">Cf N2O (gCO2/gFuel)</label>
            <input
              [(ngModel)]="newBdn.cfN2o"
              class="w-24 border px-1"
              type="number"
              id="bdn_cf_n2o"
            />
          </div>
        </div>

        <div>
          <button
            (click)="onSaveBdn()"
            class="float-right rounded-sm bg-blue-500 px-2"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  }

  <div class="reorder">
    <re-reorder-buttons (reorder)="onReorder($event)" />
  </div>

  <div class="delete absolute top-4 right-4">
    <re-trash-button (delete)="onDelete()" />
  </div>

  <h2 class="transfer-header text-center">Bunker</h2>
  <div class="container p-4">
    @if (bdn) {
      <button
        type="button"
        class="mb-2 flex w-full cursor-pointer rounded-md border px-4 py-2 text-left"
        (click)="onAddBunker()"
      >
        <h2 class="grow">
          {{ newBdn.fuelGrade }}

          <span class="bdn-ref">{{ bdn }}</span>
        </h2>

        <div>{{ newBdn.quantityReceived }}MT</div>
      </button>
    } @else {
      <div class="mb-2 flex justify-center">
        <button
          class="rounded-sm bg-blue-500 px-2"
          (click)="onAddBunker()"
        >
          Select Bunker
        </button>
      </div>
    }

    <div class="px-4">
      @for (bunkerTank of orderedTanks; track bunkerTank.tank.id) {
        <div class="tank">
          <re-tank-summary
            [tank]="bunkerTank.tank"
            [progress]="tankProgress(bunkerTank)"
            [progress2]="tankProgress2(bunkerTank)"
            [tankNumber]="bunkerTank.tank.number"
            [tankName]="bunkerTank.tank.name"
            [fuelGrade]="bunkerTank.tank.content?.fuelGrade || ''"
            [quantity]="updateTankQuantity(bunkerTank)"
          />

          <div class="flex">
            <div>
              <button
                class="rounded-sm bg-indigo-700 px-1"
                (click)="resetTank(bunkerTank)"
              >
                Reset
              </button>
            </div>
            <div class="grow text-center">
              Add:
              <input
                type="number"
                [(ngModel)]="bunkerTank.fuel.quantity"
                [min]="0"
                [max]="maxCapacity(bunkerTank)"
                (ngModelChange)="onModelChange()"
              />
              MT
            </div>
            <div>
              <button
                class="rounded-sm bg-indigo-700 px-1"
                (click)="fillTank(bunkerTank)"
              >
                Fill
              </button>
            </div>
          </div>
        </div>
      }
    </div>

    @if (isTankDropdownDisplayed) {
      <div class="p-4">
        Please select a tank:

        <select
          name=""
          id=""
          [(ngModel)]="selectedTankId"
          (change)="onSelectTank()"
        >
          <option
            value=""
            selected
          ></option>

          @for (tank of availableTanks; track tank.id) {
            <option [value]="tank.id">{{ tank.name }}</option>
          }
        </select>
      </div>
    }
  </div>
</div>
